import Vue from "vue";
import CounterApp from "../components/counter/CounterApp.vue";

export default () => {
  const numbers = document.querySelectorAll(".counter .number");
  if (!numbers) {
    return;
  }

  for(const element of numbers) {
    new Vue({
      el: element,

      components: {
        CounterApp
      },

      computed: {
        numberValue() {
          if (element.dataset.numbervalue) {
            return element.dataset.numbervalue;
          }

          return 0;
        }
      },

      render: h => h(CounterApp)
    });
  }
}
